import { render, staticRenderFns } from "./UploadTaskFiles.vue?vue&type=template&id=7c22380b"
import script from "./UploadTaskFiles.vue?vue&type=script&lang=js"
export * from "./UploadTaskFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadTaskFiles.vue?vue&type=style&index=0&id=7c22380b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports